import React from 'react';
import './Login.css';

const Login = () => {
  const loginWithDiscord = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/discord`;
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-title">Welcome to H.E.A.R.T.</h1>
        <p className="login-description">Login with your Discord account to access the terminal.</p>
        <button className="login-button" onClick={loginWithDiscord}>
          Login with Discord
        </button>
      </div>
    </div>
  );
};

export default Login;
